import { render, staticRenderFns } from "./DepartmentMsg.vue?vue&type=template&id=3a4ee922&scoped=true"
import script from "./DepartmentMsg.vue?vue&type=script&lang=js"
export * from "./DepartmentMsg.vue?vue&type=script&lang=js"
import style0 from "./DepartmentMsg.vue?vue&type=style&index=0&id=3a4ee922&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4ee922",
  null
  
)

export default component.exports